import { useSelector } from 'react-redux';

import { frontpageSelectors } from '../store/frontpageSlice';
import type { FrontpageCardTypes } from '../utils';
import { useFrontpageCardsByRole } from './useFrontpageCardsByRole';

export const useFrontpageCardSelection = () => {
    const { storedSelectedFrontpageCards } = useSelector(frontpageSelectors);
    const { allowedCards, defaultCards } = useFrontpageCardsByRole();

    const getCardsToRender = (): Array<FrontpageCardTypes> => {
        // If no user preferences, show default cards based on role
        if (
            !storedSelectedFrontpageCards ||
            storedSelectedFrontpageCards.length === 0
        ) {
            return defaultCards;
        }

        // Create a Set from stored selections for efficient lookup
        const selectedCardsSet = new Set(storedSelectedFrontpageCards);

        // Filter allowed cards to only those that are selected, maintaining order
        return allowedCards.filter((key) => selectedCardsSet.has(key));
    };

    return { cardsToRender: getCardsToRender(), allowedCards };
};
